import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategorySection() {
  const mainCategories = categories.slice(0, 8);

  return (
    <section className="px-4 md:px-6 py-14 md:py-20">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950">
            探索<span className="text-accent-500">韩漫</span>世界
          </h2>
          <p className="mt-3 text-sm text-foreground-500 max-w-md mx-auto">
            十二大分类，超万部作品，找到属于你的最爱
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {mainCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-5 md:p-6 rounded-xl bg-background-100 hover:bg-accent-50 transition-colors group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-semibold text-foreground-800">{cat.name}</span>
              <span className="text-xs text-foreground-400">{cat.count.toLocaleString()}部</span>
            </Link>
          ))}
        </div>

        <div className="flex items-center justify-center mt-8">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 text-sm text-accent-600 hover:text-accent-700 font-medium transition-colors"
          >
            查看全部分类
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}